import { useMessageContext } from '../../modules/Message'

export default function Retry() {
	const { onRetry } = useMessageContext()

	return (
		<div className='bg-orange-50 border border-orange-200 text-orange-800 px-4 py-3 rounded-lg flex flex-col gap-2 mb-2 shadow-sm'>
			<div className='text-normal'>
				Oops! Something went wrong. It could be due to an unstable internet connection or high demand on our servers. Please try again.
			</div>
			<button
				className='w-fit bg-blue-500 hover:bg-blue-600 text-white font-semibold text-sm py-1 px-3 rounded right-0'
				onClick={ onRetry }
			>
					Retry Request
			</button>
		</div>
	)
}
